<template>
  <div class="notice">
    <div class="text" v-for="( item, index ) in textList" :key="index">
      {{ item }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        textList : [
          '同乘人员、可能接触人员返家后，暂不要外出，居家封闭隔离观察。'
            + '如有发热症状请就近到网上公布的指定医院发热门诊救治。',

          '就诊过程中，要全程佩戴口罩，尽量不要乘坐公共交通工具。',

          '同乘人员、可能接触人员要第一时间到所在社区进行登记，'
            + '并与所在县（市）区疾病预防控制部门取得联系。'
        ]
      };
    }
  };
</script>

<style scoped lang="scss">
  @import "./notice.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/notice.vue